import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const EYE_ICON_WIDTH = 48;
export const THUMBNAIL_LIST_HEIGHT = 140;

interface ListItemStyledProps {
  allowSearch: boolean;
  isDisabled: boolean;
  isSelected: boolean;
  title: string | null;
}

export const useStyles = makeStyles<Theme, ListItemStyledProps | any>(
  (theme) => ({
    actionsMenu: {
      [theme.breakpoints.down('md')]: {
        top: 50,
        right: 5,
      },
      position: 'absolute',
      right: 0,
      top: 0,
    },
    brandkey: {
      backgroundColor: alpha(theme.palette.grey[800], 0.7),
      borderRadius: 2,
      color: 'white',
      left: theme.spacing(1),
      padding: theme.spacing(0, 0.5),
      position: 'absolute',
      top: theme.spacing(1),
      zIndex: 1,
    },
    busyIcon: {
      bottom: theme.spacing(1.5),
      minWidth: 'auto',
      position: 'absolute',
      right: theme.spacing(2),
    },
    media: {
      backgroundColor: theme.palette.grey[300],
      height: '100%',
      width: 'auto',
    },
    selectedIcon: ({ isDisabled, isSelected }) => ({
      bottom: theme.spacing(1.5),
      minWidth: 'auto',
      position: 'absolute',
      right: theme.spacing(2),

      '& > svg': {
        backgroundColor:
          isSelected && !isDisabled
            ? theme.palette.primary.main
            : theme.palette.grey[300],
        borderRadius: '50%',
        color: theme.palette.common.white,
      },
    }),
    title: ({ isDisabled, title }) => ({
      color: isDisabled
        ? theme.palette.grey['500']
        : title?.length
        ? theme.palette.grey['800']
        : theme.palette.grey['300'],
      fontWeight: 500,
      fontSize: 20,
      marginTop: theme.spacing(0.25),
      maxWidth: `calc(100% - ${EYE_ICON_WIDTH}px);`,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    wrapperCard: ({ isDisabled }) => ({
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(1),
      maxWidth: '895px',
      pointerEvents: isDisabled ? 'none' : 'auto',
      position: 'relative',
    }),
    wrapperContent: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      height: `calc(${THUMBNAIL_LIST_HEIGHT}px - (${theme.spacing(2)} - 1px))`,
      padding: `${theme.spacing(2, 3)} !important`,
      position: 'relative',
      width: '75%',
    },
    wrapperHeader: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',

      '& > p': {
        color: theme.palette.grey['500'],
        fontSize: '.85rem',
        paddingRight: theme.spacing(0.85),
      },
    },
    wrapperMedia: ({ isDisabled }) => ({
      filter: `grayscale(${isDisabled ? 1 : 0})`,
      flex: '1 1',
      height: `calc(${THUMBNAIL_LIST_HEIGHT}px - (${theme.spacing(2)} - 1px))`,
      minWidth: '150px',
      width: 'auto',
    }),
  }),
);
